import { faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RecurringSeriesPreview } from '@spike/new-booking-model';
import { RecurringSeriesStatus } from '@spike/new-bookings-action';
import { FunctionComponent } from 'react';
import StepSection from './StepSection';
import styles from './RecurringSeriesSteps.module.scss';

interface SummaryStepProps {
    hasRequest: boolean;
    status: RecurringSeriesStatus;
    preview: RecurringSeriesPreview | undefined;
    error: string | undefined;
    requestedCount: number | undefined;
}

export const SummaryStep: FunctionComponent<SummaryStepProps> = props => {
    const preview = props.hasRequest ? props.preview : undefined;
    const isUpdating = props.hasRequest && props.status === RecurringSeriesStatus.Previewing;

    const cards = [
        { label: 'Orders & Invoices', value: preview?.ordersCount },
        { label: 'Appointments per Booking', value: preview?.appointmentsPerOrder },
        { label: 'Products & Add‑ons', value: preview?.productsPerOrder }
    ];

    return (
        <StepSection title="Summary">
            <div className={styles.summaryCards}>
                {cards.map(card => (
                    <div
                        key={card.label}
                        className={styles.summaryCard}
                    >
                        <span className={styles.summaryValue}>
                            {isUpdating ? (
                                <FontAwesomeIcon
                                    spin
                                    icon={faSpinner}
                                />
                            ) : (
                                card.value ?? '-'
                            )}
                        </span>
                        <span className={styles.summaryLabel}>{card.label}</span>
                    </div>
                ))}
            </div>
        </StepSection>
    );
};

export default SummaryStep;
